export const getTravelInsurance = state => state.travel;
